<template>
  <div class="wrapper msc-help-page">
    <header class="msc-help-hero">
      <div
        class="msc-help-hero__media"
        aria-hidden="true"
        style="background-image: url('/img/back-to-school-start-MACVKugZ8WQ.jpg')"
      ></div>
      <div class="msc-help-hero__scrim" aria-hidden="true"></div>
      <div class="msc-help-hero__content">
        <p class="msc-help-hero__eyebrow">Help</p>
        <h1 class="msc-help-hero__title">
          Sometimes just a little help can make all the difference…
        </h1>
      </div>
    </header>

    <section class="msc-help-body">
      <div class="container msc-help-body__container">
        <ol class="msc-help-steps">
          <li class="msc-help-step">
            <div class="msc-help-step__num msc-help-step__num--1" aria-hidden="true">1</div>
            <div class="msc-help-step__content">
              <div class="msc-help-step__heading">
                <h2 class="msc-help-step__title">How to create an account</h2>
                <video-help-link
                  href="/video/parentRegistration.mp4"
                  tip="Watch a short registration video"
                />
              </div>
              <p class="msc-help-step__text">
                Your school provided a sign-up sheet with the school registration code and
                instructions. Use
                <router-link class="msc-help-step__link" to="/signup">Register For Access</router-link>
                (the green button above), then enter the school code and the other requested
                information.
              </p>
              <p class="msc-help-step__hint">
                Tap the ? help icon next to this section for a short video walkthrough.
              </p>
            </div>
          </li>

          <li class="msc-help-step">
            <div class="msc-help-step__num msc-help-step__num--2" aria-hidden="true">2</div>
            <div class="msc-help-step__content">
              <h2 class="msc-help-step__title">Then what?</h2>
              <p class="msc-help-step__text">
                We will email you a registration code. Spam filters sometimes catch these messages,
                so check your spam folder if you do not see an email from mySchool.cafe within a few
                minutes.
              </p>
            </div>
          </li>

          <li class="msc-help-step">
            <div class="msc-help-step__num msc-help-step__num--3" aria-hidden="true">3</div>
            <div class="msc-help-step__content">
              <h2 class="msc-help-step__title">Got the code — now what?</h2>
              <p class="msc-help-step__text">
                Sign in with your email and password. You will be prompted for the code after
                logging in. This is a one-time step that activates your account — you will not need
                the code again, and you can delete the email afterward.
              </p>
            </div>
          </li>
        </ol>

        <div class="msc-help-cta">
          <p class="msc-help-cta__text">Ready to get started?</p>
          <div class="msc-help-cta__actions">
            <router-link class="btn btn-success btn-round" to="/signup">
              Register For Access
            </router-link>
            <router-link class="btn btn-primary btn-round" to="/login">
              Parent Login
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { VideoHelpLink } from '@/components';

  export default {
    name: 'public-help',
    bodyClass: 'msc-help-page',
    components: {
      VideoHelpLink,
    },
  }
</script>
